import { render, staticRenderFns } from "./FormPersonalDetail.vue?vue&type=template&id=69bc88fb&"
import script from "./FormPersonalDetail.vue?vue&type=script&lang=js&"
export * from "./FormPersonalDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69bc88fb')) {
      api.createRecord('69bc88fb', component.options)
    } else {
      api.reload('69bc88fb', component.options)
    }
    module.hot.accept("./FormPersonalDetail.vue?vue&type=template&id=69bc88fb&", function () {
      api.rerender('69bc88fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/personal-detail/form/FormPersonalDetail.vue"
export default component.exports